module.exports = "/_next/static/images/mobilelocationalt-fe56b094f6e8effdb5ea81d4c6fc4904.svg";